import { render } from "./Event.vue?vue&type=template&id=bdf0f3e4&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=bdf0f3e4&scoped=true&lang=css"
import "./Event.vue?vue&type=style&index=1&id=bdf0f3e4&lang=css"

import exportComponent from "D:\\Front-end\\Beetronix\\alradwan-frontend\\vue-1\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf0f3e4"]])

export default __exports__